module.exports = __webpack_public_path__ + "static/img/qrdd.734117c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qrdd.jpg
// module id = X8hV
// module chunks = 4